import { useEffect } from 'react';

import { isDisabledPath } from './constants';
import { useAiCompanionSidebarInternal } from './AiCompanionSidebarContext';

/**
 * Hook that handles navigation behavior for the AI companion sidebar:
 * - Auto-closes when navigating to disabled paths (Graph, overlay pages)
 * - Auto-collapses to sidebar mode when navigating in fullscreen mode
 */
export const useAiCompanionNavigation = (): void => {
  const { isOpen, mode, setMode, close, currentUrl } =
    useAiCompanionSidebarInternal();

  // Close when navigating to disabled paths
  useEffect(() => {
    if (!isOpen) return;

    const pathname = currentUrl.split(/[?#]/)[0];
    if (isDisabledPath(pathname)) {
      close();
    }
  }, [currentUrl, isOpen, close]);

  // Collapse to sidebar when navigating in fullscreen mode
  useEffect(() => {
    if (mode === 'fullscreen') {
      setMode('sidebar');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUrl]);
};
